/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Laps_Legend_SlowerInputs */

const en_ui_laps_legend_slower = /** @type {(inputs: Ui_Laps_Legend_SlowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`slower`)
};

const de_ui_laps_legend_slower = /** @type {(inputs: Ui_Laps_Legend_SlowerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`langsamer`)
};

/**
* | output |
* | --- |
* | "slower" |
*
* @param {Ui_Laps_Legend_SlowerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_legend_slower = /** @type {((inputs?: Ui_Laps_Legend_SlowerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_Legend_SlowerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_legend_slower(inputs)
	return de_ui_laps_legend_slower(inputs)
});